import { render, staticRenderFns } from "./week.vue?vue&type=template&id=45dd0584&scoped=true"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=45dd0584&prod&lang=css"
import style1 from "./week.vue?vue&type=style&index=1&id=45dd0584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd0584",
  null
  
)

export default component.exports